import { useCart } from '@/context/CartContext';

function CartFloatingButton() {
  const { totalItems, setIsOpen } = useCart();

  if (totalItems === 0) return null;

  return (
    <button
      type="button"
      onClick={() => setIsOpen(true)}
      className="fixed bottom-5 right-5 z-50 w-14 h-14 flex items-center justify-center rounded-full bg-primary-600 text-white shadow-lg hover:bg-primary-700 transition-colors"
      aria-label="Abrir carrinho"
    >
      <i className="ri-shopping-bag-line text-xl" />
      {totalItems > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 flex items-center justify-center rounded-full bg-accent-500 text-white text-xs font-bold">
          {totalItems}
        </span>
      )}
    </button>
  );
}

export default CartFloatingButton;